/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGachaEnhancementExamplesResponse } from '../../models/get-gacha-enhancement-examples-response';

export interface GachaServiceGetGachaEnhancementExamples$Params {

/**
 * If you want to render a specific gacha enhancement example.
 */
  exampleGachaId?: string;
}

export function gachaServiceGetGachaEnhancementExamples(http: HttpClient, rootUrl: string, params?: GachaServiceGetGachaEnhancementExamples$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGachaEnhancementExamplesResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetGachaEnhancementExamples.PATH, 'get');
  if (params) {
    rb.query('exampleGachaId', params.exampleGachaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGachaEnhancementExamplesResponse>;
    })
  );
}

gachaServiceGetGachaEnhancementExamples.PATH = '/api/v3/gateway/gacha/enhancements';
